import { render, staticRenderFns } from "./firebase.vue?vue&type=template&id=6d65427c&scoped=true"
import script from "./firebase.vue?vue&type=script&lang=js"
export * from "./firebase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d65427c",
  null
  
)

export default component.exports